module.exports = __webpack_public_path__ + "static/desktop/img/calendar-1.dd9b749f.png";